module.exports = __webpack_public_path__ + "img/n12.bccde601.png";